import { render } from "./RegisterTurns.vue?vue&type=template&id=0c0b35d0"
import script from "./RegisterTurns.vue?vue&type=script&lang=js"
export * from "./RegisterTurns.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__